// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3joFY","search":"Settings_search__1Ay9m","filter":"Settings_filter__h9iBi"};